import React, { useState,useEffect } from "react";
import EmployeeNavbar from "./EmployeeNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function ResignationRequest() {
    const ID = Cookies.get("log_id");
    const [empname,setEmpname] = useState("");
    const [empId,setEmpid] = useState("");
    const [email,setEmail] = useState("");
    const [contact,setContact] = useState("");
    const [designation,setDesignation] = useState("");
    const [Reason,setReason] = useState("");
    function Fetch_Employee_details() {
        axios.get(`${url.path}/fetch_profile_details/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var emp = res.data.profile;
                setEmpname(emp.Employee_Name);
                setEmpid(emp.Employee_ID);
                setEmail(emp.Email);
                setContact(emp.Contact_number);
                setDesignation(emp.Designation);
            }
        }).catch((err) => {
            console.log("ERROR", err);
          }); 
    }
    useEffect(()=>{
        Fetch_Employee_details();
    },[])
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    function handleResignation(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('name',empname);
        formdata.append('empid',empId);
        formdata.append('email',email);
        formdata.append('contact',contact);
        formdata.append('reason',Reason);
        axios.post(`${url.path}/resignation_request/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Resignation Request Submitted..'
                })
                Fetch_Employee_details();
            }
        }).catch((err) => {
            console.log("ERROR", err);
            if (!err.response.data.status) {
                Toast.fire({
                  icon: "error",
                  title: `${err.response.data.message}`,
                });
              }
          });
    }
    return(
        <>
        <EmployeeNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Resignation Request</h1>
                </div>
                <br />
                <form onSubmit={handleResignation}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Employee Name</label>
                            <input type="text" value={empname} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Employee ID</label>
                            <input type="text" value={empId} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="text" value={email} readOnly />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Contact</label>
                            <input type="text" value={contact} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Designation</label>
                            <input type="text" value={designation} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Reason For Resignation</label>
                            <input type="text" value={Reason} onChange={(e) =>setReason(e.target.value)} />
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Request</button>
                        </div>
                    </center>
                </form>
            </div>
        </div>
        </>
    );
}
export default ResignationRequest;